import { extend } from '@pixi/react';
import { Container, Graphics, Sprite, TilingSprite } from 'pixi.js';

extend({
  Container,
  Graphics,
  Sprite,
  TilingSprite,
});
